import { ILand } from "@/modules/pe-fest-module/data/interfaces"
import LandContent from "./LandContent"

interface IProps {
    item : ILand
    onClose: () => void
    onOpenLogin? : () => void
}
const TeamContent = (props: IProps) : JSX.Element => {
    return <LandContent {...props} /> 
} 

export default TeamContent